import { WebWearableService } from './web';
export default WebWearableService;
